// localStorage-first persistence for Gunsi Tally.
// Phase 2 (backend sync) will replace these with /tally/* fetches.

const KEY = 'gunsi_tally_data_v1'

export function defaultData() {
  return {
    currency: 'EUR',
    categories: [],    // { id, name, type ('income'|'expense'), icon (emoji), parentId? }
    transactions: [],  // { id, date (ISO datetime), type, categoryId?, amount, currency?, name?, note? }
  }
}

export function loadData() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return defaultData()
    const parsed = JSON.parse(raw)
    return { ...defaultData(), ...parsed }
  } catch {
    return defaultData()
  }
}

export function saveData(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data))
  } catch {}
}

export function clearData() {
  try {
    localStorage.removeItem(KEY)
  } catch {}
}
